module.exports = __webpack_public_path__ + "static/media/lancia-go-drive.9d0eccf3.jpg";